// extracted by mini-css-extract-plugin
export default {"container":"Admin_container__+ZLsP","subContainer":"Admin_subContainer__A-DnZ","feed":"Admin_feed__II7pz"};